import React from 'react';
import { Provider, connect } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import PublicRoutes from './router';
import { store, history } from './redux/store';
import { queryClient } from './query/client';
import themes from './settings/themes';
import AppLocale from './languageProvider';
import { themeConfig } from './settings';
import DashAppHolder from './dashAppStyle';
import Boot from './redux/boot';


const AppContent = ({ locale }) => {
  const currentAppLocale = AppLocale[locale];
  return (
    <ConfigProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ThemeProvider theme={themes[themeConfig.theme]}>
          <DashAppHolder>
            <QueryClientProvider client={queryClient}>
              <PublicRoutes history={history} />
            </QueryClientProvider>
          </DashAppHolder>
        </ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
};

const ConnectedAppContent = connect((state) => ({
  locale: state.LanguageSwitcher.language.locale,
}))(AppContent);

const DashApp = () => (
  <Provider store={store}>
    <ConnectedAppContent />
  </Provider>
);
Boot()
  .then(() => DashApp())
  .catch(error => console.error(error));

export default DashApp;
export { AppLocale };
